





















































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import * as api from '@/store/api';
import alert from '@/store/modules/alert';

@Component({})
export default class TeamEditor extends Vue {
  @Prop() readonly subSlide!: any;
  @Prop({ default: false }) readonly hideTitle!: boolean;

  // Form state for adding new member
  newMemberName: string = '';
  newMemberRole: string = '';
  newMemberImageBlobId: string = '';
  isUploadingImage: boolean = false;
  isDraggingImage: boolean = false;

  // Editing state
  editingMemberIndex: number | null = null;

  // Drag and drop state
  draggedMemberIndex: number | null = null;

  get title(): string {
    return this.subSlide.title || '';
  }

  set title(value: string) {
    this.subSlide.title = value;
  }

  get teamMembers(): any[] {
    return this.subSlide.teamMembers || [];
  }

  addMember() {
    if (!this.newMemberName.trim()) {
      return;
    }
    if (!this.subSlide.teamMembers) {
      this.subSlide.teamMembers = [];
    }
    this.subSlide.teamMembers.push({
      name: this.newMemberName,
      role: this.newMemberRole,
      imageBlobId: this.newMemberImageBlobId,
    });
    // Clear form
    this.newMemberName = '';
    this.newMemberRole = '';
    this.newMemberImageBlobId = '';
    this.onUpdate();
  }

  // Image upload methods
  onImageFileChange(e: any) {
    const files = e.target.files || e.dataTransfer.files;
    if (!files.length) {
      return;
    }
    this.uploadImage(files[0]);
  }

  uploadImage(file: File) {
    const me = this;
    const formData = new FormData();
    formData.append('file', file);

    me.isUploadingImage = true;
    api
      .uploadBlob(formData)
      .then((response: any) => {
        me.isUploadingImage = false;
        me.newMemberImageBlobId = response.data;
      })
      .catch((error) => {
        me.isUploadingImage = false;
        const apiError =
          error.error && error.error.response && error.error.response.data
            ? error.error.response.data
            : 'Kunde inte ladda upp bild';
        alert.setError(apiError);
      });
  }

  onImageDrop(event: any) {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file) {
      this.uploadImage(file);
    }
    this.isDraggingImage = false;
  }

  onImageDragEnter(event: any) {
    event.preventDefault();
    this.isDraggingImage = true;
  }

  onImageDragLeave(event: any) {
    event.preventDefault();
    this.isDraggingImage = false;
  }

  onImageDragOver(event: any) {
    event.preventDefault();
  }

  onClickImageUpload() {
    const fileInput = this.$refs.imageInput as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  getNewMemberImageSrc() {
    if (this.newMemberImageBlobId) {
      return `/api/user/blob/${this.newMemberImageBlobId}`;
    }
    return null;
  }

  deleteMember(index: number) {
    if (this.subSlide.teamMembers) {
      this.subSlide.teamMembers.splice(index, 1);
      if (this.editingMemberIndex === index) {
        this.editingMemberIndex = null;
      }
      this.onUpdate();
    }
  }

  // Member editing methods
  startEditingMember(index: number) {
    this.editingMemberIndex = index;
  }

  saveMemberEdit(index: number) {
    if (this.editingMemberIndex === index) {
      this.editingMemberIndex = null;
      this.onUpdate();
    }
  }

  cancelMemberEdit() {
    this.editingMemberIndex = null;
  }

  onMemberImageChange(event: any, index: number) {
    const file = event.target.files[0];
    if (file) {
      this.uploadMemberImage(file, index);
    }
  }

  uploadMemberImage(file: File, index: number) {
    const me = this;
    const formData = new FormData();
    formData.append('file', file);

    api
      .uploadBlob(formData)
      .then((response: any) => {
        if (me.subSlide.teamMembers[index]) {
          me.subSlide.teamMembers[index].imageBlobId = response.data;
          me.onUpdate();
        }
      })
      .catch((error) => {
        const apiError =
          error.error && error.error.response && error.error.response.data
            ? error.error.response.data
            : 'Kunde inte ladda upp bild';
        alert.setError(apiError);
      });
  }

  onClickMemberImage(index: number) {
    const refs = this.$refs[`memberImageInput-${index}`] as
      | HTMLInputElement
      | HTMLInputElement[];
    const fileInput = Array.isArray(refs) ? refs[0] : refs;
    if (fileInput) {
      fileInput.click();
    }
  }

  getMemberImageSrc(imageBlobId: string) {
    if (imageBlobId) {
      return `/api/user/blob/${imageBlobId}`;
    }
    return null;
  }

  // Drag and drop methods for reordering
  onDragStartMember(event: any, index: number) {
    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.setData('text/plain', index.toString());
    this.draggedMemberIndex = index;
  }

  onDragEnterMember(event: any, index: number) {
    if (this.draggedMemberIndex !== null && index !== this.draggedMemberIndex) {
      this.reorderMembers(this.draggedMemberIndex, index);
      this.draggedMemberIndex = index;
    }
  }

  onDragEndMember() {
    this.draggedMemberIndex = null;
  }

  onDropMember(event: any, index: number) {
    event.preventDefault();
    this.draggedMemberIndex = null;
  }

  reorderMembers(fromIndex: number, toIndex: number) {
    if (!this.subSlide.teamMembers) {
      return;
    }
    const movedMember = this.subSlide.teamMembers.splice(fromIndex, 1)[0];
    this.subSlide.teamMembers.splice(toIndex, 0, movedMember);
    this.onUpdate();
  }

  onUpdate() {
    this.$emit('update');
  }
}
